import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { debounce } from 'lodash';
import { Delete } from '../icons';
import { Button } from '../buttons';
import './GlossaryItem.css';

const GlossaryItem = props => {
  const container = useRef(null);
  const [display, setDisplay] = useState(false);
  const [isRight, setIsRight] = useState(false);

  const closeGlossaryCard = () => {
    setDisplay(false);
  };

  const openGlossaryCard = () => {
    setDisplay(true);
  };

  useEffect(() => {
    // check if word is on left/right side of screen
    const handleResize = () => {
      setIsRight(
        container.current.offsetLeft + 20 * 16 > window.innerWidth - 16
      );
    };
    handleResize();
    // debounce resize function so only called after a certain amount of tiime, after the new screensize is set
    const handleResizeDebounced = debounce(handleResize, 100);
    window.addEventListener('resize', handleResizeDebounced);
    return () => {
      window.removeEventListener('resize', handleResizeDebounced);
    };
  }, []);

  const { anchor, title, content } = props;

  return (
    // To accomplish both the hover on large screens and click on mobile
    <button
      ref={container}
      className="glossary-item"
      tabIndex="0"
      onFocus={openGlossaryCard}
      onMouseOver={openGlossaryCard}
      onMouseLeave={closeGlossaryCard}
    >
      {anchor}
      <div
        className={`glossary-item-card ${display ? '--display' : ''} ${
          isRight ? '--right' : ''
        }`}
      >
        <Button
          tabIndex="0"
          onKeyPress={closeGlossaryCard}
          onClick={closeGlossaryCard}
          className="modal__close-button glossary-item-card__close"
          ariaLabel="Close Tooltip"
        >
          <Delete viewBox="8 8 16 16" />
        </Button>
        {title}
        {content}
      </div>
    </button>
  );
};

GlossaryItem.propTypes = {
  anchor: PropTypes.node.isRequired,
  title: PropTypes.node.isRequired,
  content: PropTypes.node.isRequired
};

export default GlossaryItem;



// WEBPACK FOOTER //
// ./src/components/GlossaryItem/GlossaryItem.js